import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ThemeProvider, createTheme } from '@mui/material';

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.(prev => !prev)}
      style={{ fontSize: '17px', textTransform: 'none' }}
    >
      {label ? `${label}` : t('Pick_a_date')}
    </Button>
  );
}

function ButtonDatePicker(props) {
  const [open, setOpen] = React.useState(false);

  const customTheme = createTheme({
    typography: {
      fontSize: 17,
    },
  });
  return (
    <ThemeProvider theme={customTheme}>
      <DatePicker
        slots={{ field: ButtonField, ...props.slots }}
        slotProps={{ field: { setOpen } }}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        {...props}
      />
    </ThemeProvider>
  );
}

//component for date pick functionality
export default function PickDate(props) {
  const {
    dateFormat = 'MMM DD, YYYY',
    value,
    setValue,
    disabled,
    defaultValue = null,
  } = props;

  const formatDefaultDate = defaultValue ? dayjs(defaultValue) : null;
  const formattedDatevalue = value ? dayjs(value) : null;
  const dateValue =
    formattedDatevalue !== null
      ? formattedDatevalue.format(dateFormat)
      : formatDefaultDate !== null
        ? formatDefaultDate.format(dateFormat)
        : null;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ButtonDatePicker
        label={dateValue}
        value={formattedDatevalue}
        onChange={newValue => setValue(newValue)}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
}
